import { Controller } from '@hotwired/stimulus';

/**
 * Controller for the remove invoice choice modal
 * Handles toggling between choice view and reject form view
 */
export default class extends Controller {
  static targets = ['choiceView', 'rejectForm', 'rejectionReason'];

  connect() {
    // Initialize in choice view
    this.showChoiceView();
  }

  /**
   * Show the choice cards, hide the reject form
   */
  showChoiceView() {
    this.choiceViewTarget.classList.remove('hidden');
    this.rejectFormTarget.classList.add('hidden');
  }

  /**
   * Show the reject form, hide the choice cards
   */
  showRejectForm(event) {
    if (event) {
      event.preventDefault();
    }
    this.choiceViewTarget.classList.add('hidden');
    this.rejectFormTarget.classList.remove('hidden');
    // Focus the rejection reason textarea
    this.rejectionReasonTarget.focus();
  }

  /**
   * Submit the detach form (card click)
   */
  submitDetach(event) {
    if (event) {
      event.preventDefault();
    }
    // Find the detach form and submit it
    const form = this.element.querySelector('[data-remove-invoice-choice-form="detach"]');
    if (form) {
      form.submit();
    }
  }
}
